import React, { useRef, memo, useState, useEffect, useCallback } from 'react';
import * as PropTypes from 'prop-types';
import styles from './ColumnResizer.scss';

let ColumnResizer = (props) => {
	const { column } = props;
	const resizeInitialWidth = useRef();
	const resizeInitialX = useRef();
	const currentWidth = useRef();
	const [dragging, setDragging] = useState(false);

	useEffect(() => {
		if (dragging) {
			const onBodyMouseMove = (e) => {
				const diffX = e.pageX - resizeInitialX.current;
				currentWidth.current = resizeInitialWidth.current + diffX;
				column.resize(currentWidth.current);
			};
			const onBodyMouseUp = () => setDragging(false);

			document.addEventListener('mousemove', onBodyMouseMove);
			document.addEventListener('mouseup', onBodyMouseUp);
			return () => {
				document.removeEventListener('mousemove', onBodyMouseMove);
				document.removeEventListener('mouseup', onBodyMouseUp);
			};
		}
		return undefined;
	}, [column, dragging]);

	const onResizerMouseDown = useCallback((e) => {
		const cell = e.target.parentElement;
		resizeInitialWidth.current = cell.offsetWidth;
		resizeInitialX.current = e.pageX;
		currentWidth.current = resizeInitialX.current;
		setDragging(true);
	}, []);

	return (
		<div
			data-tag='col-resizer'
			className={styles.ColumnResizer}
			onMouseDown={onResizerMouseDown}
		/>
	);
};
ColumnResizer = memo(ColumnResizer);
ColumnResizer.propTypes = {
	column: PropTypes.object,
};

export { ColumnResizer };
